<template>
  <div class="page">
    <nav-bar/>
    <search-bar/>

    <div class="mt20" style="width: 100%">
      <div
          class="page-content"
          style="padding-bottom: 100px; margin-bottom: 75px"
      >
        <div class="p10" style="border-bottom: 10px solid #f5f5f5">
          <el-breadcrumb separator-class="el-icon-arrow-right" class="mt10 mb10">
            <el-breadcrumb-item :to="{ path: '/me/myCustomer' }">我的客户</el-breadcrumb-item>
            <el-breadcrumb-item>{{ company_info.company_name }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!--        -->

        <div class="fc jc ac">
          <!--          企业资料-->
          <div class="mt30">
            <div class="fz18">企业资料</div>

            <div class="company-info fr ac p30 mt10">
              <!--              左边-->
              <img style="width: 120px; height: 120px" :src="company_info.company_logo" alt/>
              <!--              右边-->
              <div class="ml20" style="width: 100%">
                <div class=" ellipsis-1line">{{ company_info.company_name }}</div>
                <div class="grey ellipsis-1line">{{ company_info.company_tel }}</div>
                <div class="grey ellipsis-1line"> {{
                    company_info.company_province + company_info.company_city + company_info.company_country + company_info.company_address
                  }}
                </div>
                <div class="fr ac jfe cursor pt30">
                  <div class="fr jc ac">
                    <img style="width: 16px; height: 16px" src="/static/imgs/me/placeAnOrder.png" alt/>
                    <div class="ml10" @click="proxyCustomer">代客下单</div>
                  </div>
                  <div @click="toUpdate" class="fr jc ac ml20 mr30 cursor">
                    <img style="width: 16px; height: 16px" src="/static/imgs/me/modify.png" alt/>
                    <span class="ml10">编辑</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <!--我的订单-->
          <div class="mt30" v-if="false">
            <div class="fz18">我的订单</div>
            <div class="order mt10 p30 fr ac">
              <div
                  class="item cursor"
                  @click="go(`/me/myCustomerOrder?type=1&company_id=${company_info.company_id}`)">
                <img src="/static/imgs/me/pendingPayment.png" alt style="width: 38px; height: 38px"/>
                <span class="mt20">待确认</span>
              </div>

              <div
                  class="item cursor"
                  @click="go(`/me/myCustomerOrder?type=4&company_id=${company_info.company_id}`)">
                <img src="/static/imgs/me/toBeDelivered.png" alt style="width: 37px; height: 40px"/>
                <span class="mt20">待发货</span>
              </div>

              <div
                  class="item cursor"
                  @click="go(`/me/myCustomerOrder?type=5&company_id=${company_info.company_id}`)">
                <img src="/static/imgs/me/toBeReceived.png" alt style="width: 42px; height: 34px"/>
                <span class="mt20">待收货</span>
              </div>

              <div
                  class="item cursor"
                  @click="go(`/me/myCustomerOrder?type=6&company_id=${company_info.company_id}`)">
                <img src="/static/imgs/me/comment.png" alt style="width: 36px; height: 33px"/>
                <span class="mt20">待评价</span>
              </div>

              <div
                  class="item cursor"
                  @click="go(`/me/myCustomerOrder?type=9999&company_id=${company_info.company_id}`)">
                <img src="/static/imgs/me/after.png" alt style="width: 38px; height: 38px"/>
                <span class="mt20">售后</span>
              </div>
            </div>
          </div>
        </div>

        <!--              我的同事-->
        <div class="mt30 fc ac jc" v-show="workmate_list.length">
          <div class="fz18">员工列表</div>
          <div class="company-info mt10">
            <div class="item fr jsb ac p30" v-for="(item, index) in workmate_list" :key="index">
              <div class="fr ac">
                <img :src="item.member_img" alt style="width: 60px; height: 60px"/>
                <div class="ml20">
                  <div class="fr ac">
                    <div>{{ item.member_nick_name }}</div>
                    <div class="member-role ml40">{{ item.role_name }}</div>
                  </div>
                  <div class="mt20">{{ item.member_account }}</div>
                </div>
              </div>
              <div>
                <i class="el-icon-arrow-right" style="font-size: 27px"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";

export default {
  data() {
    return {
      company_info: {
        company_id: "",
      },
      company_id: "",
      workmate_list: []
    };
  },
  watch: {
    $route(n) {
      if (n.path != "/myCustomer/customerInfo") {
        this.$store.commit('setCompanyId', '')
        return;
      }
      let param = this.$route.query;
      this.company_id = param.company_id;
      this.getCompanyInfo();
      this.getWorkMateList();
    },
  },
  mounted() {
    let param = this.$route.query;
    this.company_id = param.company_id;
    this.$store.commit('setCompanyId', this.company_id)
    this.getCompanyInfo();
    this.getWorkMateList();
  },

  methods: {
    getWorkMateList() {
      let param = {
        auth_type: 2,
        relation_id: this.company_id,
      };
      this.post("memberRoleInterfaces/v1.0/getCompanyWorkmateList", param).then(
          (res) => {
            this.workmate_list = res.data;
          }
      );
    },
    //进入代客下单模式
    async proxyCustomer() {
      // 获取客户特殊要求列表
      let res = await this.post(
          "companyRequirement/getCompanyRequirementList",
          {
            company_id: this.$route.query.company_id,
          }
      );
      let arr = [];
      res.data.forEach(el => {
        arr.push(`<p>${el.content}</p>`);
      })
      this.$alert(arr.join(' '), '客户特殊要求', {
        dangerouslyUseHTMLString: true
      }).then(res => {
        this.substitution();
      })

    },
    // 替换身份信息
    substitution() {
      this.post("auth/salesProxyCompanyLogin", {
        company_id: this.$route.query.company_id,
      }).then((res) => {
        let obj = this.$store.state.memberInfo;
        let permission_ids = this.$store.state.permission_ids;

        this.memberInfoInit(res.data);
        this.$store.commit("setSaleInfo", obj);
        this.$store.commit('setSalePermission_ids', permission_ids);
        this.go("/home/index");
      });
    },
    //去修改公司信息页面
    toUpdate() {
      this.$store.commit('setCompanyInfo',)
      this.go('/myCustomer/updateCustomer')
      // this.$router.push({
      //   path: "/myCustomer/updateCustomer",
      //   query: {
      //     company_info: JSON.stringify(this.company_info),
      //   },
      // });
    },
    //获取公司信息
    getCompanyInfo() {
      let param = {
        company_id: this.company_id,
      };
      this.post("memberInterfaces/v1.0/getSellCompany", param).then((res) => {
        this.company_info = res.data;
      });
    },
  },
  destroyed() {
    this.$store.commit('setCompanyId', '')
  },
  components: {
    "nav-bar": NavBar,
    "search-bar": SearchBar,
    "footer-bar": FooterBar,
  },
};
</script>

<style scoped lang="scss">
.page-content {
  width: 1200px;
  margin: 0px auto;
  background-color: #ffffff;
}

.company-info {
  width: 920px;
  background: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.16);
}

/*    我的订单*/
.order {
  width: 920px;
  height: 140px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  opacity: 1;

  .item {
    width: 172px;
    /*flex-grow: 1;*/
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myCustomer/customerInfo.vue